import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

import { APP_DESCRIPTION } from '../constants';

const HeadComponent = ({ BRAND_NAME, title, description, canonicalLink }) => (
    <Helmet>
        <title>{`${BRAND_NAME} - ${title}`}</title>
        <meta name="description" content={description ? description : APP_DESCRIPTION} />
        <link rel="canonical" href={canonicalLink} />
    </Helmet>
);

const mapStateToProps = state => ({
    BRAND_NAME: state.i18n.common.BRAND_NAME
});

export default connect(mapStateToProps)(HeadComponent);



// WEBPACK FOOTER //
// ./src/components/HeadComponent.js